var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name !== 'Login'),expression:"$route.name !== 'Login'"}]}),_c('main',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }